'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTH_ERROR_TYPES = exports.LINK_TYPE_PARAMS = exports.LINK_TYPES = exports.MEETING_TYPES = exports.DEFAULT_FORM_FIELD_NAMES = exports.FORM_FIELDS_WITH_OPTIONS = exports.FORM_FIELD_TYPES = exports.CAL_INTEGRATIONS = undefined;

var _reactUtils = require('react-utils');

var _Immutable = require('Immutable');

var CAL_INTEGRATIONS = exports.CAL_INTEGRATIONS = (0, _reactUtils.keyMirror)({
  GOOGLE: null,
  OFFICE365: null,
  CALDAV: null,
  UNKNOWN: null
});

var FORM_FIELD_TYPES = exports.FORM_FIELD_TYPES = {
  DATE: 'date',
  NUMBER: 'number',
  TEXT: 'string',
  TEXTAREA: 'textarea',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  BOOLEAN_CHECKBOX: 'booleancheckbox',
  ENUMERATION: 'enumeration'
};

var FORM_FIELDS_WITH_OPTIONS = exports.FORM_FIELDS_WITH_OPTIONS = [FORM_FIELD_TYPES.RADIO, FORM_FIELD_TYPES.CHECKBOX, FORM_FIELD_TYPES.BOOLEAN_CHECKBOX, FORM_FIELD_TYPES.ENUMERATION];

var DEFAULT_FORM_FIELD_NAMES = exports.DEFAULT_FORM_FIELD_NAMES = (0, _reactUtils.keyMirror)({
  FIRST_NAME: null,
  LAST_NAME: null,
  EMAIL: null
});

var MEETING_TYPES = exports.MEETING_TYPES = {
  PERSONAL: 'personal',
  GROUP: 'group',
  ROUND_ROBIN: 'roundRobin'
};

var LINK_TYPES = exports.LINK_TYPES = (0, _Immutable.Map)({
  personal: 'PERSONAL_LINK',
  group: 'GROUP_CALENDAR',
  roundRobin: 'ROUND_ROBIN_CALENDAR'
});

var LINK_TYPE_PARAMS = exports.LINK_TYPE_PARAMS = (0, _Immutable.Map)({
  personal: 'personal',
  team: 'team'
});

var AUTH_ERROR_TYPES = exports.AUTH_ERROR_TYPES = (0, _reactUtils.keyMirror)({
  USER_DECLINED: null,
  SHARED_INBOX_INVALID_DOWNGRADE: null,
  DEFAULT: null,
  SHARED_INBOX: null
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/constants/enums.js
// module id = 42
// module chunks = 0